import authAxiosInstance from "@/sevices/authAxiosInstance";
import { ReservationList } from "@/types/Reservation";

interface GetReservationsBySoldToIdRequestParams {
  userId: string;
  soldToId: string;
  pageSize?: number;
  pageStartKey?: string;
}

export const getReservationsBySoldToId = async ({
  userId,
  soldToId,
  pageSize,
  pageStartKey
}: GetReservationsBySoldToIdRequestParams): Promise<ReservationList> => {
  try {
    const res = await authAxiosInstance({
      url: `reservationservice/reservations/user/${userId}/soldToOrg/${soldToId}`,
      method: "GET",
      params: {
        pageSize,
        pageStartKey
      }
    });
    return res?.data;
  } catch (error) {
    throw error;
  }
};
